/* @flow */
import type {MarketId} from './types';

// Disable products that are not available in the current market and sort them to the bottom
export function orderProductsByMarketAvailability(
    products: Object[],
    marketId: MarketId
): Object[] {
    const enabledProducts = [];
    const disabledProducts = [];

    products.forEach((product) => {
        if (product.prices[marketId] && product.prices[marketId].isAvailable) {
            enabledProducts.push(product);
        } else {
            disabledProducts.push({...product, isDisabled: true});
        }
    });

    return enabledProducts.concat(disabledProducts);
}
